import type { ConnectionEnvName } from '../../types/settings.types.js';

export const SUPPORTED_ENVS: ConnectionEnvName[] = ['local', 'development', 'staging', 'production'];

export function assertEnvName(env: string): ConnectionEnvName {
    if (SUPPORTED_ENVS.includes(env as ConnectionEnvName)) {
        return env as ConnectionEnvName;
    }
    throw new Error(`Unsupported env '${env}'. Use one of: ${SUPPORTED_ENVS.join(', ')}`);
}

export function redactSecret(value: string | undefined, showSecrets: boolean): string | undefined {
    if (!value || showSecrets) return value;
    return '***';
}

export function redactUrl(urlValue: string | undefined, showSecrets: boolean): string | undefined {
    if (!urlValue || showSecrets) return urlValue;
    try {
        const parsed = new URL(urlValue);
        if (parsed.password) parsed.password = '***';
        return parsed.toString();
    } catch {
        return '***';
    }
}
